export default __webpack_public_path__ + "b86c512c69d4924eaca64521ceaa9c5a.png";